import mendeleev from "@/urls/mendeleev"
import {
  sendGetRequest, sendPostRequest
} from "@/helper/requests"

const state = {
  agreements: {
    currentUrl: null,
    items: [],
    loading: false,
    count: 0,
    detail: [],
    next: null,
    prev: null,
    error: null,
  }
}

const getters = {
  getAgreements: state => state.agreements.items,
  getAgreementsCount: state => state.agreements.count,
  getAgreementsCurrentUrl: state => state.agreements.currentUrl,
  getAgreementsNext: state => state.agreements.next,
  getAgreementsPrev: state => state.agreements.prev,
  getAgreementsDetail: state => state.agreements.detail,
  isLoadingAgreements: state => state.agreements.loading,
  saveAgreementsError: state => state.agreements.error,
}

const actions = {
  loadAgreements: ({ commit, getters }, { finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.INFOS.AGREEMENTS.LIST()
    if (!getters.isLoadingAgreements) {
      commit('SET_AGREEMENTS_LOADING')
      sendGetRequest(
        url, (data, url) => {
          commit('SET_AGREEMENTS', data)
          commit('SET_AGREEMENTS_LOADING_END')
          finalizer(data, url)
        }, (data, url) => {
          commit('SET_AGREEMENTS_LOADING_END')
          commit('SAVE_AGREEMENTS_ERROR', data)
          catcher(data, url)
        }
      )
    }
  },
  acceptAgreements: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
    const url = mendeleev.USER.INFOS.AGREEMENTS.ACCEPT()
    commit('SET_AGREEMENTS_LOADING')
    sendPostRequest(
      url, data, (data, url) => {
        commit('SET_AGREEMENTS_LOADING_END')
        finalizer(data, url)
      }, (data, url) => {
        commit('SET_AGREEMENTS_LOADING_END')
        catcher(data, url)
      }
    )
  },
  // updateAgreements: ({ commit }, { data, finalizer = () => {}, catcher = () => {} }) => {
  //   const url = mendeleev.USER.MEMBER.AGREEMENTS.UPDATE()
  //   commit('SET_AGREEMENTS_LOADING')
  //   sendPostRequestFile(
  //     url, data, (data, url) => {
  //       commit('SET_AGREEMENTS_LOADING_END')
  //       finalizer(data, url)
  //     }, (data, url) => {
  //       commit('SET_AGREEMENTS_LOADING_END')
  //       catcher(data, url)
  //     }
  //   )
  // },
  // loadAgreementsDetail: ({commit}, {url, id, finalizer=()=>{}, catcher=()=>{}}) => {
  //   if (!url) url = url = mendeleev.USER.AGREEMENTS.AGREEMENTS.DETAIL(id)
  //   sendGetRequest(
  //     url, (data, url) => {
  //       commit('SET_AGREEMENTS_DETAIL', data);
  //       finalizer(data, url);
  //     }, (data, url) => {
  //       commit('SAVE_AGREEMENTS_ERROR', data);
  //       catcher(data, url);
  //     }
  //   )
  // },
}

const mutations = {
  SET_AGREEMENTS: (state, value) => {
    state.agreements.items = value
  },
  SET_AGREEMENTS_DETAIL: (state, value) => {
    state.agreements.detail = value
  },
  SET_AGREEMENTS_COUNT: (state, value) => {
    state.agreements.count = value
  },
  SET_AGREEMENTS_CURRENT_URL: (state, value) => {
    state.agreements.currentUrl = value
  },
  SET_AGREEMENTS_NEXT_URL: (state, value) => {
    state.agreements.next = value
  },
  SET_AGREEMENTS_PREV_URL: (state, value) => {
    state.agreements.prev = value
  },
  SET_AGREEMENTS_LOADING: (state) => {
    state.agreements.loading = true
  },
  SET_AGREEMENTS_LOADING_END: (state) => {
    state.agreements.loading = false
  },
  SAVE_AGREEMENTS_ERROR: (state, error) => {
    state.agreements.error = error
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
